import { LandingPageCoordinatesTypename, WebsitePageCoordinatesTypename, WebInteractiveCoordinatesTypename, LandingPageVariantGenerationInputsTypename, WebsitePageVariantGenerationInputsTypename, WebInteractiveVariantGenerationInputsTypename } from 'personalization-lib/__generated__/chirp/com/hubspot/personalize/rpc/PersonalizeRpc';
export const ASSET_TYPES = {
  LANDING_PAGE: 'LANDING_PAGE',
  WEBSITE_PAGE: 'WEBSITE_PAGE',
  WEB_INTERACTIVE: 'WEB_INTERACTIVE'
};
export const SUPPORTED_ASSET_TYPES = [ASSET_TYPES.LANDING_PAGE, ASSET_TYPES.WEBSITE_PAGE, ASSET_TYPES.WEB_INTERACTIVE];
export const AI_SUPPORTED_ASSET_TYPES = [ASSET_TYPES.LANDING_PAGE, ASSET_TYPES.WEBSITE_PAGE, ASSET_TYPES.WEB_INTERACTIVE];
export const ASSET_TYPE_TO_COORDINATES = {
  [ASSET_TYPES.LANDING_PAGE]: LandingPageCoordinatesTypename,
  [ASSET_TYPES.WEBSITE_PAGE]: WebsitePageCoordinatesTypename,
  [ASSET_TYPES.WEB_INTERACTIVE]: WebInteractiveCoordinatesTypename
};
export const ASSET_TYPE_TO_AI_INPUTS_TYPENAME = {
  [ASSET_TYPES.LANDING_PAGE]: LandingPageVariantGenerationInputsTypename,
  [ASSET_TYPES.WEBSITE_PAGE]: WebsitePageVariantGenerationInputsTypename,
  [ASSET_TYPES.WEB_INTERACTIVE]: WebInteractiveVariantGenerationInputsTypename
};